var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"logout","light":""}},[_c('v-layout',{staticStyle:{"margin-top":"1em"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }